import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Outlet } from 'react-router-dom'
import { 
	CContainer,
	CFade,
} from '@coreui/react'
import { UFunc } from "../helpers/functions"

const Error404 = require('../views/Error404').default;

const ContContent=(props)=>{
	const uDispatch 			= useDispatch();

	const uEfekapp 				= useSelector(state => state.effectApp);
	const uRoutes				= JSON.parse(localStorage.getItem("routeslist") || "[]");
	const uPathname 			= (window.location.pathname);

	const vRouteArr				= uRoutes.filter((vItems) => vItems.path === uPathname );

	React.useEffect(()=>{
		if(vRouteArr.length <= 0){ 
			uDispatch({type: "set", activeRoute: ""});
			return;
		}

		let TheComponent;
		try {
			TheComponent = require("../views/"+UFunc.capitalize(vRouteArr[0].name)).default;
		} catch (ex) {
			uDispatch({type: "set", activeRoute: ""});
			return;
		}

		uDispatch({type: "set", activeRoute: vRouteArr[0].name});
	},[vRouteArr])
	/*React.useEffect(()=>{
		console.log("(ContContent - [uEfekapp]) uEfekapp => "+(uEfekapp));
	},[uEfekapp])//-*/

	//console.log("ContContent - uPathname => "+(uPathname));
	return (
		<CContainer fluid className="px-0">
		<Outlet {...props}/>
		</CContainer>
	)//>
}

export default ContContent